import { createFileRoute } from "@tanstack/react-router";
import { GitBranch } from "lucide-react";

import { PageShell } from "@/components/layouts/shells/page-shell";
import { ResourcesRoadmap } from "@/features/resources/modules/roadmap/roadmap";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/resources/roadmap/")({
  loader: () => ({ crumb: m.better_studio_nav_resources_roadmap() }),
  component: ResourcesRoadmapPage,
});

function ResourcesRoadmapPage() {
  return (
    <PageShell
      icon={GitBranch}
      badge={m.better_studio_resources_card_roadmap_meta()}
      title={m.better_studio_nav_resources_roadmap()}
      description={m.better_studio_roadmap_description()}
      demo
    >
      <ResourcesRoadmap />
    </PageShell>
  );
}
